import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { overviewApi } from "../http/Api";

export const getOverview = createAsyncThunk('Overview/getOverview', async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
        const response = await overviewApi.getOverview(serverId);
    console.log('response',response);

    if(response.status === 200) {
        thunkAPI.dispatch(overviewSlice.actions.setOverview(response))
    }
})

export const getOverviewInfo = createAsyncThunk('Overview/getOverviewInfo', async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
        const response = await overviewApi.getOverviewInfo(serverId);
    console.log('response',response);

    if(response.status === 200) {
        thunkAPI.dispatch(overviewSlice.actions.setOverviewInfo(response))
    }
})

const initialState = {
    overviewGlobalState: null,
    overviewInfoGlobalState: null,
}

const overviewSlice = createSlice({
    name: 'overview',
    initialState,
    reducers: {
        setOverview: (state, action) => {
            state.overviewGlobalState = action.payload
        },
        setOverviewInfo: (state, action) => {
            state.overviewInfoGlobalState = action.payload
        }
    }
})

export const overview = overviewSlice.reducer;
